module.exports = __webpack_public_path__ + "static/big-data-specialty-8060b0395ce3874e2a896c1464aa9ac3.png";